import { constants } from '@wsb/guac-widget-core';
import { last } from 'lodash';
import platforms from '../../constants/platforms';
import { TWITCH_REGEX } from '../../constants/regex';

const { TWITCH, YOUTUBE } = platforms;
const { PREVIEW } = constants.renderModes;
const { MOBILE_RENDER_DEVICE } = constants.renderDevices;

function prependProtocol(rawUrl) {
  return /^https?:\/\//.test(rawUrl) ? rawUrl : 'https://' + rawUrl;
}

function getStreamChannel(platform, url) {
  if (platform === TWITCH) {
    const { pathname } = new URL(prependProtocol(url));
    return pathname.slice(1);
  }
  return '';
}

function getStreamId(platform, url) {
  if (platform === YOUTUBE) {
    if (/youtu\.be\/./.test(url)) {
      const { pathname } = new URL(prependProtocol(url));
      return pathname.slice(1);
    } else if (/youtube\.com\/embed\/./.test(url)) {
      const { pathname } = new URL(prependProtocol(url));
      return last(pathname.split('/'));
    } else if (/youtube\.com/.test(url)) {
      const { searchParams } = new URL(prependProtocol(url));
      return searchParams.get('v');
    }
  }
  return '';
}

export function buildStreamUrl({ platform, channel, url, renderMode, viewDevice, parentDomain }) {
  const isMobilePreview = renderMode === PREVIEW && viewDevice === MOBILE_RENDER_DEVICE;
  return {
    [TWITCH]: [
      'https://player.twitch.tv/',
      `?channel=${TWITCH_REGEX.test(channel) ? getStreamChannel(TWITCH, channel) : channel}`,
      '&autoplay=false',
      `&muted=${isMobilePreview}`,
      `&parent=${parentDomain}`
    ].join(''),
    [YOUTUBE]: [
      'https://www.youtube.com/',
      `embed/${getStreamId(platform, url)}`,
      '?autoplay=false',
      `&mute=${isMobilePreview}`
    ].join('')
  }[platform];
}

export function buildChatUrl({ platform, channel, url, parentDomain }) {
  channel = TWITCH_REGEX.test(channel) ? getStreamChannel(platform, channel) : channel;
  return {
    [TWITCH]: [
      `https://www.twitch.tv/embed/${channel}/chat`,
      `?id=${channel}`,
      `&parent=${parentDomain}`
    ].join(''),
    [YOUTUBE]: [
      'https://www.youtube.com/live_chat',
      `?v=${getStreamId(platform, url)}`,
      `&embed_domain=${parentDomain}`,
      `&app=desktop` // chat won't render for mobile without this
    ].join('')
  }[platform];
}
